import React, { useEffect, useState } from "react";
import CardLoading from "../../../../components/CardLoading";
import { Table } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import useModalToggle from "../../../../custom_hooks/useModalToggle";
import moment from "moment";
import ProfileView from "../../jobs/recommendation/ProfileView";
import { fetchData } from "../../../../features/dropdown/dropdownSlice";

function Candidates() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = "api/v1/applications/filter";
  const { loading, data, count, activeObjActivity } = useSelector((state) => ({
    loading: state.dropdown.loading,
    data: state.dropdown.data[url] || [],
    count: state.dropdown.count[url] || 0,
    activeObjActivity: state.folder.activeObj["activity"],
  }));

  const { open, handleCancel, handleOpen } = useModalToggle();

  const showDrawer = () => {
    handleOpen();
  };
  const onClose = () => {
    handleCancel();
  };

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const handleViewName = async (item) => {
    await setProdd(item);
    await showDrawer();
  };

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      width: "5%",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Applicant",
      render: (item) => {
        return (
          <div className="cursor-pointer" onClick={() => handleViewName(item)}>
            {item?.japFirstName} {item?.japLastName}
          </div>
        );
      },
      sorter: (a, b) => a.name.localeCompare(b.name),
    },

    {
      title: "Job Match",
      dataIndex: "japMatchingScore",
      render: (item) => {
        return (
          <div className="py-[.25rem] px-[.5rem] flex items-center justify-center gap-[.625rem] rounded-[.25rem] bg-[#569D6E] opacity-[0.8]">
            {item}
          </div>
        );
      },
    },
    {
      title: "Date",
      dataIndex: "japInterviewDate",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"),
      sorter: (a, b) =>
        moment(a.japInterviewDate).valueOf() -
        moment(b.japInterviewDate).valueOf(),
    },
    {
      title: "Start Time",
      dataIndex: "japInterviewStartTime",
    },
    {
      title: "End Time",
      dataIndex: "japInterviewEndTime",
    },
  ];
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        japJaaId: activeObjActivity?.jaaId,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
  }, []);

  if (loading && !searchInput) return <CardLoading />;
  return (
    <>
      <Table
        rowSelection={false}
        className="mt-[1rem] w-full"
        scroll={{
          x: "auto",
        }}
        rowKey={(record) => record?.japId}
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={{
          position: ["bottomRight"],
          current: pageIndex + 1,
          total: count,
          pageSize: pageSize,
          onChange: (page, size) => {
            setPageIndex(page - 1);
            setPageSize(size);
            fetchTableData(page - 1, size);
          },
          showSizeChanger: false,
          hideOnSinglePage: true,
        }}
      />
      <ProfileView
        onClose={onClose}
        openDrawer={open}
        prodd={prodd}
        action={true}
      />
    </>
  );
}

export default Candidates;
